<template>
    <div class="header-margin col-sm-8 mx-auto p-4">
        <div v-if="(! isLoaded)">
            <h3>{{ $t('account.2sa.title') }}</h3>
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>
        <div v-else>
            <h3>{{ $t('account.2sa.title') }}</h3>
            <!-- 2段階認証設定状況 -->
            <div class="mt-3">
                <span class="mr-3">{{ $t('account.2sa.ga') }}</span>
                <span v-if="isActive" class="tsa-enabled tsa-status">                
                    <span class="dot" /><span class="ml-2 text-success">{{ $t('account.2sa.enabled') }}</span>
                </span>
                <span v-else class="tsa-disabled tsa-status">
                    <span class="dot" /><span class="ml-2 text-black-50">{{ $t('account.2sa.disabled') }}</span>
                </span>
            </div>

            <!-- 有効化ペイン -->
            <div v-if="isActive" class="mt-4">
                <h4>{{ $t('account.2sa.disable2sa') }}</h4>
            </div>
            <div v-else class="mt-4">
                <h4>{{ $t('account.2sa.2saSettings') }}</h4>
                <!-- QRコード表示 -->
                <!-- PC -->
                <div v-if="! isTouchableDevice">
                    <div class="text-center">
                        <qriously v-bind:value="url" :size="200" level="M" id="qr" />
                    </div>
                    <div class="mt-5 secret-key">
                        {{ $t('account.2sa.16digitsKey') }} : <span><strong>{{ formData.secret }}</strong></span>
                    </div>
                </div>

                <!-- タブレット/スマートフォン -->
                <div v-else class="mt-2">
                    <div class="text-center">
                        <qriously v-bind:value="url" :size="200" level="M" id="qr-touch-device" />
                    </div>
                    <div class="row">
                        <label for="secretKey" class="col-form-label col">{{ $t('account.2sa.16digitsKey') }}</label>
                        <label class="text-success text-right col-form-label col" id="copied">{{ $t('account.2sa.copied')}}</label>
                    </div>
                    <div class="input-group">
                        <input type="text" class="form-control" id="secretKey" v-bind:value="formData.secret" disabled />
                        <div class="input-group-append">
                            <button type="button" ref="copyButton" id="copyButton" class="btn btn-outline-primary rounded-right modal-copy-btn" @click="copyButtonHandler()">
                                {{ $t('token.deposit.copy-label') }}
                            </button>
                        </div>
                    </div>
                </div>

                <p class="mt-3">{{ $t('account.2sa.caution1') }}</p>

            </div>

            <!-- 入力フォーム -->
            <form @submit.prevent="handleOnSubmit" class="mt-3">
                <div class="form-group row">
                    <label for="password" class="col-sm-4 col-form-label">{{ $t('account.2sa.loginPassword') }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.password" type="password" id="password" name="password" class="form-control"
                            v-bind:class="{ 'is-invalid': errors.password}"/>
                        <div v-if="errors.password" class="invalid-feedback">{{ $t('errors.' + errors.password) }}</div>
                    </div>
                </div>

                <div class="form-group row">
                    <label for="oneTimeCode" class="col-sm-4 col-form-label">{{ $t('account.2sa.authenticationCode') }}</label>
                    <div class="col-sm-8">
                        <input v-model="formData.oneTimeCode" type="text" id="oneTimeCode" name="oneTimeCode" class="form-control"
                            v-bind:class="{ 'is-invalid': errors.oneTimeCode}"/>
                        <div v-if="errors.oneTimeCode" class="invalid-feedback">{{ $t('errors.' + errors.oneTimeCode) }}</div>
                    </div>
                </div>

                <div v-if="isActive" class="mt-4">
                    <div class="col-md-6 mt-md-0 mx-auto px-0">
                        <button v-on:submit.prevent type="submit" class="btn btn-danger btn-block mt-3">{{ $t('account.2sa.disable2sa') }}</button>
                    </div>

                </div>
                <div v-else class="mt-4">
                    <p class="mx-auto col-sm-10 px-0" v-html="$t('account.2sa.caution2')"></p>
                    <div class="text-center mt-3">
                        <input type="checkbox" id="checkbox" v-model="isReadyBackup16bitkey">
                        <label for="checkbox">{{ $t('account.2sa.isReadyBackup16bitkey') }}</label>
                    </div>
                    <div class="col-md-6 mt-md-0 mx-auto px-0">
                        <button v-on:submit.prevent type="submit" class="btn btn-primary btn-block mt-3" :disabled="! isReadyBackup16bitkey">
                            {{ $t('account.2sa.enable2sa') }}
                        </button>
                    </div>

                </div>
            </form>
        </div>

    </div>
</template>

<script>
    import userService from '../../services/UserService';
    import $ from 'jquery'
    import vueQriously from 'vue-qriously';
    import textUtil from './../../utils/TextUtil';

    export default {
        name: 'google2sa-settings',

        components: {
            vueQriously,
        },


        data() {
            return {
                isLoaded: false,
                isActive: true,
                isReadyBackup16bitkey: false,
                url: "",
                formData: this.initFormData(),
                errors: this.initErrors(),
            }
        },

        created() {
            this.fetch();
        },

        methods: {
            async handleOnSubmit() {
                try {
                    // 2段階認証の有効/無効で処理を分ける
                    if (this.isActive) {
                        // 無効化
                        let isReady = this.checkInputValue();
                        if (isReady) {
                            const result = await userService.deactivate2sa(this.formData);
                            this.erros = this.initErrors();
                            this.formData = this.initFormData();
                            this.isReadyBackup16bitkey = false;
                            this.applyData(result.data);
                        }
                    } else {
                        // 有効化
                        let isReady = this.checkInputValue();
                        if (isReady) {
                            const result = await userService.activate2sa(this.formData);
                            this.erros = this.initErrors();
                            this.formData = this.initFormData();
                            this.isReadyBackup16bitkey = false;
                            this.applyData(result.data);
                        }
                    }
                } catch (error) {
                    error.response.data.errors.forEach(error => {
                        if (error.field) {
                            console.log(error.message[0]);
                            this.errors[error.field] = error.message[0];
                        }
                    });
                }

            },

            /**
             * 入力値検証
             * @returns bool
             */
            checkInputValue() {
                // エラーを全てクリア
                this.errors = this.initErrors();

                let verified = true;
                if (!this.formData.password) {
                    this.errors.password = 'LOGIN_PASSWORD_SHOULD_NOT_EMPTY';
                    verified = false;
                }
                if (!this.formData.oneTimeCode.trim()) {
                    this.errors.oneTimeCode = 'ONE_TIME_CODE_SHOULD_NOT_EMPTY';
                    verified = false;
                }
                return verified;
            },
            
            /**
             * 初期化
             */
            initFormData() {
                return {
                    secret: "",
                    password: "",
                    oneTimeCode: "",
                };
            },

            /**
             * エラー値初期化
             */
            initErrors() {
                return {
                    password: '',
                    oneTimeCode: '',
                };
            },

            copyButtonHandler() {
                textUtil.copyToClipboard(this.formData.secret);

                this.showCopiedMessage();
                this.$refs.copyButton.blur();
            },

            /**
             * 「コピーしました」メッセージのアニメーション表示
             */
            showCopiedMessage() {
                $('#copied').css('visibility', 'visible');
                $('#copied').animate({ opacity: 1 }, {
                    duration: 1000,
                    complete: function () {
                        $('#copied').animate({ opacity: 0 }, { 
                            duration: 1000, 
                            easing: 'swing',
                            complete: function() {
                                $('#copied').css('visibility', 'hidden');
                                $('#copied').css('opacity', '1');
                            } 
                        });
                    }
                });
            },

            async fetch() {
                const result = await userService.get2saStatus();

                this.applyData(result.data);
                this.isLoaded = true;
            },

            applyData(data) {
                this.isActive = data.active;
                this.formData.secret = data.secret;
                this.url = data.url;
            },
        },

        computed: {
            isTouchableDevice: function() {
                return typeof window.ontouchstart !== "undefined" && navigator.maxTouchPoints > 0;
            }
        }
    }
</script>

<style scoped>
    .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        vertical-align: middle;
    }

    .tsa-enabled > .dot {
        background: #28a745;
    }

    .tsa-disabled > .dot {
        background: gray;
    }

    #qr {
        display: block;
        float: left;
        margin: 0px 30px 30px 100px;
    }

    #qr-touch-device {
        margin: 30px auto 0 auto;
    }

    form {
        clear: both;
    }

    .secret-key {
        font-size: 1.2em;
    }

    #copyButton {
        white-space: nowrap;
    }

    #copyButton:hover {
        color: white !important;
    }

    #copied {
        visibility: hidden;
    }

    /* QRコード・16桁キーレイアウト調整 */
    @media screen and (max-width: 890px) { 
        .tsa-status {
            float: right;
        }

        #qr {
            margin: 30px auto 0 auto;
            float: none;   
        }
    } 
</style>
